var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLighTtrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.333 2.99967H13.6663V4.33301H12.333V12.9997C12.333 13.1765 12.2628 13.3461 12.1377 13.4711C12.0127 13.5961 11.8432 13.6663 11.6663 13.6663H2.33301C2.1562 13.6663 1.98663 13.5961 1.8616 13.4711C1.73658 13.3461 1.66634 13.1765 1.66634 12.9997V4.33301H0.333008V2.99967H3.66634V0.999674C3.66634 0.822863 3.73658 0.653294 3.8616 0.52827C3.98663 0.403246 4.1562 0.333008 4.33301 0.333008H9.66634C9.84315 0.333008 10.0127 0.403246 10.1377 0.52827C10.2628 0.653294 10.333 0.822863 10.333 0.999674V2.99967ZM10.9997 4.33301H2.99967V12.333H10.9997V4.33301ZM4.99967 6.33301H6.33301V10.333H4.99967V6.33301ZM7.66634 6.33301H8.99967V10.333H7.66634V6.33301ZM4.99967 1.66634V2.99967H8.99967V1.66634H4.99967Z",
    fill: "#9BA5B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLighTtrash);
export default __webpack_public_path__ + "static/media/LIGHT trash.3f18989d931075f79605b597bffdc841.svg";
export { ForwardRef as ReactComponent };